import {useSelector} from "react-redux";
import {trackEvent} from "util/eventUtil";
import {TextType, TrackingEventType} from "@pinch-financial/pinch-ui-components";
import {getContactInfo} from "store/selectors/basicInfo";
import {NoLendersPage as NoLendersPageUI} from "@pinch-financial/pinch-ui-components";
import i18next from "i18next";
import NavigationBar from "components/NavigationBar/NavigationBar";
import {useTranslation} from "react-i18next";
import usePageText from "~/hooks/usePageText";
interface Props {
  onPrevPage?: () => any;
  containerRef?: React.RefObject<HTMLDivElement>;
}

const NoLendersPage = ({onPrevPage, containerRef}: Props) => {
  const {t: fixedT} = useTranslation("", {keyPrefix: "noLendersPage"});
  const {getText, status: textStatus} = usePageText("NO_LENDERS_URL");

  const {email} = useSelector(getContactInfo);

  return (
    <NoLendersPageUI
      loading={textStatus === "not-started" || textStatus === "pending"}
      containerRef={containerRef}
      header={getText(TextType.APP_PAGE_HEADER) ?? fixedT("header")}
      body={
        <span
          dangerouslySetInnerHTML={{
            __html:
              getText(TextType.APP_PAGE_BODY, {email: email}) ?? fixedT("body", {email: email})!,
          }}
        />
      }
      onBack={() => {
        trackEvent(TrackingEventType.lenderNoQualificationClickEdit);
        onPrevPage?.();
      }}
      buttonText={getText(TextType.APP_PAGE_BACK_BUTTON) ?? i18next.t("backButton")}
      navigationBar={<NavigationBar />}
    />
  );
};

export default NoLendersPage;
